const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://ykchannel-api.localhost";

export const getApiBaseUrl = () => API_BASE_URL.replace(/\/+$/, "");

export const getToken = () => localStorage.getItem("token");

export const setToken = (token) => {
  localStorage.setItem("token", token);
};

export const clearToken = () => {
  localStorage.removeItem("token");
};

const buildHeaders = (extraHeaders = {}, useJson = true) => {
  const headers = {
    Accept: "application/json",
    ...extraHeaders,
  };

  if (useJson) {
    headers["Content-Type"] = "application/json";
  }

  const token = getToken();

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

const extractValidationMessages = (errors) => {
  if (!errors || typeof errors !== "object") return [];

  return Object.values(errors)
    .flatMap((value) => (Array.isArray(value) ? value : [value]))
    .filter((value) => typeof value === "string" && value.trim())
    .map((value) => value.trim());
};

export const apiRequest = async (path, options = {}) => {
  const {
    method = "GET",
    body,
    headers,
    useJson = true,
    ...rest
  } = options;

  const response = await fetch(`${getApiBaseUrl()}${path}`, {
    method,
    headers: buildHeaders(headers, useJson),
    body: body === undefined ? undefined : useJson ? JSON.stringify(body) : body,
    ...rest,
  });

  const contentType = response.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");
  const payload = isJson ? await response.json() : await response.text();

  if (!response.ok) {
    const validationMessages = isJson
      ? extractValidationMessages(payload.errors)
      : [];
    const message =
      validationMessages.join(" ") ||
      (isJson && (payload.message || payload.error)) ||
      `Request failed with status ${response.status}`;

    const error = new Error(message);
    error.status = response.status;
    error.payload = payload;
    throw error;
  }

  return payload;
};

export const extractList = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.data)) return payload.data;
  if (Array.isArray(payload.items)) return payload.items;
  return [];
};
